import * as React from 'react'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ExportDatesRange from '../../ExportFields/ExportDatesRange'
import ExportEmployeeSelector from '../../ExportFields/ExportEmployeeSelector'

interface Props {
  form: ReportsForm
}

const UsedTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ExportDatesRange form={form} />
    </>
  )
}

export default UsedTimeoffFields
